import React, { CSSProperties, useEffect, useState } from 'react';

import { t } from 'i18next';
import { DateTime } from 'luxon';
import { useDispatch } from 'react-redux';

import DatePicker from 'components/Input/DatePicker/DatePicker';

import './DailyMessage.scoped.scss';
import { getAllStudents } from 'redux/liveClass/students.slices';
import TimePicker from 'components/Input/TimePicker/TimePicker';
import ModalDialog from 'components/ModalDialog/ModalDialog';

import Students from '../../views/LiveClass/components/TeacherDashboard/components/students/Index';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  openModal?: boolean;
  handleModal?: () => void;
  handleCloseModal: () => void;
  onInputChange?: (id: string, mark: number) => void;
  responding?: any;
  generalMessage?: string;
  location?: string;
}

const DailyMessageModal: React.FC<Props> = ({ openModal, handleModal, handleCloseModal }) => {
  const [title, setTitle] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [startTime, setstartTime] = useState('');
  const [endTime, setendTime] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllStudents(''));
  }, []);

  return (
    <ModalDialog
      open={openModal}
      onClose={handleModal}
      title={'Make a message of the day'}
      actions={[
        {
          type: 'decline',
          colour: 'primary',
          label: t('common:cancel'),
          handler: handleCloseModal,
        },
        {
          type: 'filled',
          colour: 'primary',
          label: t('common:Make'),
          handler: handleModal,
        },
      ]}
    >
      <div className="dailymessage-modal-container">
        <div className=" flex column margin-x-10px">
          <label htmlFor="className">
            <h4>{t('Title')}</h4>
          </label>
          <input
            value={title}
            type="text"
            className="input"
            onChange={e => setTitle(e.target.value)}
          />
        </div>

        <div className="date-time-range-container">
          <div className="dailymessage-modal-date">
            <div className="date-picker">
              <label htmlFor="date-picker">
                <h4>{t('Start-Time')}</h4>
                <TimePicker
                  onChange={e => {
                    const data = e.split(':');
                    const starting_at = DateTime.fromISO(startTime)
                      .set({
                        hour: data[0],
                        minute: data[1],
                      })
                      .toString();
                    setstartTime(starting_at);
                  }}
                  value={DateTime.fromISO(startTime).toFormat('HH:mm')}
                />
              </label>
            </div>
            <div className="date-picker-ct">
              <label htmlFor="date-picker">
                <h4>{t('End Time')}</h4>
                <TimePicker
                  onChange={e => {
                    const data = e.split(':');
                    const ending_at = DateTime.fromISO(endTime)
                      .set({
                        hour: data[0],
                        minute: data[1],
                      })
                      .toString();
                    setendTime(ending_at);
                  }}
                  value={DateTime.fromISO(startTime).toFormat('HH:mm')}
                />
              </label>
            </div>
          </div>

          <div className="dailymessage-modal-date">
            <div className="date-picker">
              <label htmlFor="date-picker">
                <h4>{t('Start Date')}</h4>
              </label>
              <DatePicker
                value={startDate}
                onChange={({ dateStr }) => {
                  setStartDate(dateStr);
                }}
              />
            </div>
            <div className="date-picker-ct">
              <label htmlFor="date-picker">
                <h4>{t('End Date')}</h4>
              </label>
              <DatePicker
                value={endDate}
                onChange={({ dateStr }) => {
                  setEndDate(dateStr);
                }}
              />
            </div>
          </div>
        </div>
        <div className="description flex column margin-x-10px">
          <label htmlFor="description">
            <h4>{t('Description')}</h4>
          </label>
          <textarea id="description" className="input border-radius-10px" rows={10} />
        </div>

        <div className="students-container">
          <Students />
        </div>
      </div>
    </ModalDialog>
  );
};

export default DailyMessageModal;
